export type FormValues = {
  answers: Array<{
    answerText: string | undefined;
    selectedAnswerOptions: number[] | undefined;
    mark: number | undefined;
  }>;
};

export const defaultFormValues: FormValues = {
  answers: [],
};
